/* globals urls, themeObj, symposium, validate, RSVP */

var $ = jQuery.noConflict();

window.ClinicalInstructorMeeting = function(){
	this.RSVP = RSVP;
	this.formSelector = '#symp-ci-meeting-form';
	this.formMessagingSelector = this.formSelector + ' .message-target';
	this.onRegPage = $(this.formSelector).length > 0;
	//remove seat constraint
	this.constraints = {
		
	};
};

// Add this Clinical Instructor Meeting registration to the user's cart and redirect them to the appropriate page or display an error message
ClinicalInstructorMeeting.prototype.addToCart = function(currentCartItem){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'add_ci_meeting_to_cart',
				currentCartItem: currentCartItem || ''
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.redirect );
			}
			reject( res.message || 'An error occurred while adding your registration to the cart' );
		});
	});
};

// Update reserved seat in the user's session and return the an object representing the new seat's data or an error message
ClinicalInstructorMeeting.prototype.updateSeatFields = function(seatData){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'update_ci_program_seat_data',
				seatId: seatData.seatId,
				seatNumber: seatData.seatNumber,
				seatExpiration: seatData.seatExpiration
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( {
					seatId: res.data.seatId,
					seatNumber: res.data.seatNumber,
					seatExpiration: res.data.seatExpiration,
					seatExpirationFormatted: res.data.seatExpirationFormatted,
					newCartItemKey: seatData.cartItemKey
				} );
			}
			reject( res.message || 'An error occurred while updating your registration' );
		});
	});
};

(function($, SymposiumRegistration, ClinicalInstructorMeeting) {
	
	if( ClinicalInstructorMeeting.onRegPage ){
		// Refresh the page if the user got here using the back/forward browser button
		SymposiumRegistration.refreshOnBackNavigation();
		
		$('body').on( 'kois.seatReserved', function(e, seatData){
			SymposiumRegistration.updateLoadingState(true);
			ClinicalInstructorMeeting.updateSeatFields( seatData ).then(function(registrationSeatData){
				// If the cart item was replaced as part of the seat update, refresh the page with the cart item key in the URL query string
				if( registrationSeatData.newCartItemKey ){
					window.location.href = window.location.pathname + '?cart_item=' + registrationSeatData.newCartItemKey;
				}
				// Otherwise update the appropriate fields and allow the user to continue editing
				else{
					// Update form fields
					$( ClinicalInstructorMeeting.formSelector + ' input[name="ReservedSeat"]' ).val( registrationSeatData.seatId );
					$( ClinicalInstructorMeeting.formSelector + ' input[name="ReservedSeatNumber"]' ).val( registrationSeatData.seatNumber );
					$( ClinicalInstructorMeeting.formSelector + ' input[name="ReservedSeatExpiration"]' ).val( registrationSeatData.seatExpiration );
					// Update displayed seat info
					$( ClinicalInstructorMeeting.formSelector + ' .selected-seat-number-display' ).html( registrationSeatData.seatNumber );
					$( ClinicalInstructorMeeting.formSelector + ' .selected-seat-expiration-display' ).html( registrationSeatData.seatExpirationFormatted );
					// Remove loading state and display seating info
					$('#selected-seat-info').removeClass( 'hidden' );
					SymposiumRegistration.updateLoadingState(false);
				}
			}).catch(function(error){
				SymposiumRegistration.showRegistrationErrors( ClinicalInstructorMeeting.formMessagingSelector, {}, 'Registration Error', error );
			});
		} );
	}
	
	$(ClinicalInstructorMeeting.formSelector).submit(function(e){
		e.preventDefault();
		
		SymposiumRegistration.clearRegistrationErrors( ClinicalInstructorMeeting.formMessagingSelector );
		SymposiumRegistration.updateLoadingState(true);
		var objRegistrationData = validate.collectFormValues(e.target);
		var objConstraints = ClinicalInstructorMeeting.constraints;
		var objValidationErrors = SymposiumRegistration.validate(objRegistrationData, objConstraints);
		console.log(objValidationErrors);
		if( objValidationErrors ){
			SymposiumRegistration.showRegistrationErrors( ClinicalInstructorMeeting.formMessagingSelector, objValidationErrors );
		}
		else{
			ClinicalInstructorMeeting.addToCart(objRegistrationData.CurrentCartItem).then(function(redirect){
				//console.log(redirect);
				window.location = redirect;
			}).catch(function(error){
				// Display add to cart error message
				SymposiumRegistration.showRegistrationErrors( ClinicalInstructorMeeting.formMessagingSelector, {}, 'Registration Error', error );
			});
		}
	});
})(jQuery, new SymposiumRegistration(), new ClinicalInstructorMeeting());